import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { css } from "glamor";
import { DragDropVerticalIcon } from "@hugeicons/react";

export const SortableSection = ({ 
  id, 
  children 
}: { 
  id: string; 
  children: React.ReactNode;
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div 
      ref={setNodeRef} 
      style={style} 
      {...css({ 
        position: "relative",
        marginBottom: 24,
        "&:hover .drag-handle": {
          opacity: 0.6,
        },
      })}
    >
      {/* Drag handle - appears on hover */}
      <div
        className="drag-handle"
        {...attributes}
        {...listeners}
        {...css({
          position: "absolute",
          top: 8,
          right: 8,
          cursor: "grab",
          padding: 6,
          background: "white",
          borderRadius: 6,
          opacity: 0,
          transition: "opacity 0.2s",
          zIndex: 10,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          ":hover": {
            opacity: 1,
          },
          ":active": {
            cursor: "grabbing",
          },
        })}
      >
        <DragDropVerticalIcon size={20} color="#666" />
      </div>
      {children}
    </div>
  );
};
